export default "__VITE_ASSET__B52S$L$F__"